import { getConfigObject } from './config.selectors';

export const getChildren = ({ cms }) => cms.children;
export const getContent = ({ cms }) => cms.content;
export const getSelectedParentPage = ({ cms }) => cms.selectedParentPage;
